import { useGuestJourneyStageConfig } from 'api/reports-service/guest-journey-hooks';
import { GuestJourneyStageGrid } from 'api/reports-service/guest-journey-reports.types';
import { selectStageGridCells } from 'api/reports-service/guest-journey-settings.utils';
import { useQuickCreateCommunicationOptional } from 'components/drawers/quick-create-communication-drawer/quick-create-communication.context';
import { useQuickCreateLocationContext } from 'components/drawers/quick-create-communication-drawer/quick-create-communication.location';
import SegmentGrid from 'components/segment-grid/segment-grid.component';
import { SegmentMetric } from 'components/segment-grid/segment-grid.types';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export type SlidersGridProps = {
  data?: GuestJourneyStageGrid;
  loading?: boolean;
};

const SlidersGrid = ({ data, loading = false }: SlidersGridProps) => {
  const { t } = useTranslation();
  const [metric, setMetric] = useState<SegmentMetric>('count');
  const { stageConfig, isFetching: settingsFetching } =
    useGuestJourneyStageConfig();
  const quickCreate = useQuickCreateCommunicationOptional();
  const location = useQuickCreateLocationContext();

  return (
    <SegmentGrid
      title={t('page.guestJourney.sliders.gridTitle')}
      spendTiers={stageConfig?.spendTiers ?? []}
      visitTiers={stageConfig?.visitTiers ?? []}
      cells={selectStageGridCells(data, metric)}
      metric={metric}
      onMetricChange={setMetric}
      showMetricToggle
      showMovementBadge
      showMovementLegendButton
      variant="sliders"
      onCellAction={
        quickCreate
          ? action =>
              quickCreate.openQuickCreateCommunication({
                kind: 'segment',
                ...action,
                population: 'sliders',
                ...location,
              })
          : undefined
      }
      loading={loading || settingsFetching}
      data-testid="Sliders.SegmentGrid"
    />
  );
};

export default SlidersGrid;
